import axios from 'axios'
import { apiHost } from '../config/env.conf'

export default {
    
    /**
     * 获取订单列表数据
     * @param { int } orderState -1 全部，0 新单，1 待发货，2 已发货
     * 3 发货失败，4 已签收，5 申请退款，6 退款成功
     */
    getOrderListData(orderState, form, currentPage) {
        let params = {};
        params.orderState = orderState;
        if (form) {
            for (let key in form) {
                if (form[key].trim() !== '') {
                    params[key] = form[key].trim();
                }
            }
        }
        if (currentPage) {
            params.offset = (currentPage - 1) * 20;
        }
        return axios.get(`cci/core/v1/order/list`, {
            params: params
        });
    },
    
    /**
     * 获取订单详情
     * @param { int } orderId 订单ID
     */
    getOrderDetails(orderId) {
        return axios.get(`cci/core/v1/order/detail`, {
            params: {
                orderId: orderId
            }
        });
    },
    
    /**
     * 发货
     * @param { int }    orderId     订单ID
     * @param { string } deliverCode 快递公司编号
     * @param { string } deliverNo   快递单号
     */
    sendProduct(orderId, deliverCode, deliverNo) {
        const params = {
            orderId: orderId,
            deliverCode: deliverCode,
            deliverNo: deliverNo
        }
        let q = new URLSearchParams();
        for (let i in params) {
            q.append(i, params[i]);
        }
        return axios.post(`cci/core/v1/order/deliver`, q.toString(), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    },
    
    /**
     * 放弃
     * @param { int }    orderId  订单ID
     * @param { int }    reason   放弃理由
     * @param { string } describe 描述
     */
    reject(orderId, reason, describe) {
        const params = {
            orderId: orderId,
            reason: reason,
            describe: describe
        }
        let q = new URLSearchParams();
        for (let i in params) {
            q.append(i, params[i]);
        }
        return axios.post(`cci/core/v1/order/reject`, q.toString(), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    },
    
    /**
     * 退款
     * @param { int }    orderId 订单ID
     * @param { int }    status  1 同意，2 拒绝
     * @param { string } message 原因
     */
    handleRefund(orderId, status, message) {
        const params = {
            orderId: orderId,
            status: status,
            message: message
        }
        let q = new URLSearchParams();
        for (let i in params) {
            q.append(i, params[i]);
        }
        return axios.post(`/cci/core/v1/order/handleRefund`, q.toString(), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
    },
    
    /**
     * 获取快递列表
     */
    getExpressInfo() {
        return axios.get(`cci/core/v1/deliver/company/list`);
    },
    
    /**
     * 下载
     */
    downloadOrder(params) {
        let str = '';
        for (let k in params) {
            if (params[k] !== '') {
                str += k + '=' + params[k] + '&';
            }
        }
        window.open(`${apiHost}/cci/core/v1/order/export?${str}`);
    }
    
}


// WEBPACK FOOTER //
// ./src/api/wenchuang.js